import { Store } from '@ngrx/store';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { TextSizes, TextType } from 'src/app/shared/enums';
import { IShop } from 'src/app/shared/services/user/user.type';
import { befreeUrlValues } from 'src/app/shared/constants';
import { IFavoriteStateOfShop } from 'src/app/shared/interfaces';
import { selectLoadingStateOfShop } from 'src/app/data/store/selectors/shop.selectors';
import { selectCurrentPlatform } from 'src/app/data/store/selectors/platform.selectors';
import { copyOnLongPress } from 'src/app/shared/utils/gestures/longPress';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { AsyncPipe } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../image/image.component';
import { TextComponent } from '../text/text.component';
import { AddBaseUrlPipe } from '../../pipe/add-baseUrl/add-base-url.pipe';
@Component({
  selector: 'app-shop-card',
  templateUrl: './shop-card.component.html',
  styleUrls: ['./shop-card.component.scss'],
  imports: [IonicModule, RouterLink, ImageComponent, TextComponent, AsyncPipe, AddBaseUrlPipe],
})
export class ShopCardComponent implements OnDestroy, AfterViewInit {
  private _store = inject(Store);
  utils = inject(UtilsService);

  @Input() shop: IShop | undefined;

  @Output() emitShopFavoriteState: EventEmitter<IFavoriteStateOfShop> =
    new EventEmitter<IFavoriteStateOfShop>();

  @ViewChild('shopLocation') shopLocation?: ElementRef<HTMLDivElement>;

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  public platform$ = this._store.select(selectCurrentPlatform);

  public isFavStateLoading$ = this._store.select(selectLoadingStateOfShop);

  private _locationCopyUnsubscribe: VoidFunction = () => {
    // no-op: обработка по умолчанию
  };

  get shopUrl() {
    return [
      '/',
      befreeUrlValues.dashboard,
      befreeUrlValues.shopList,
      this.shop!.id,
      befreeUrlValues.employees,
    ];
  }

  ngAfterViewInit(): void {
    if (this.shopLocation && this.shop?.city && this.shop?.house) {
      this._locationCopyUnsubscribe = copyOnLongPress(
        this.shopLocation.nativeElement,
        [this.shop.city.name, this.shop.house].join(', '),
      );
    }
  }

  ngOnDestroy(): void {
    this._locationCopyUnsubscribe();
  }

  public emitIsShopFavorite(id: number, isFavorite: boolean) {
    this.emitShopFavoriteState.emit({
      id,
      isFavorite,
    });
  }

  public onLinkClick(event: MouseEvent) {
    event.stopPropagation();
  }

  public onFavClick(
    event: MouseEvent,
    isLoading: boolean | null,
    shopId: number,
    isFavorite: boolean,
  ) {
    event.preventDefault();
    event.stopPropagation();
    if (!isLoading) {
      this.emitIsShopFavorite(shopId, isFavorite);
    }
  }
}
